import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Menu } from '@lumapps/lumx-menu/components/Menu';
import { mdiApps } from '@lumapps/lumx/icons';
import { Link as RouterLink } from '@lumapps/router';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { userDirectories } from '../../routes';

export interface UserDirectoriesSettingsMenuProps {
    /** Whether the menu entry should render — gated by feature flag + permission upstream. */
    isAllowed: boolean;
    scope: string;
}

export const UserDirectoriesSettingsMenu: React.FC<UserDirectoriesSettingsMenuProps> = ({ isAllowed, scope }) => {
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(scope);

    if (!isAllowed) {
        return null;
    }

    return (
        <Menu.Item icon={mdiApps} as={RouterLink} to={userDirectories()} {...get({ element: 'user-directories' })}>
            {translateKey(GLOBAL.USER_DIRECTORIES)}
        </Menu.Item>
    );
};

UserDirectoriesSettingsMenu.displayName = 'UserDirectoriesSettingsMenu';
